import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExportButtonComponent } from '@app/manage-view/export-creative/export-button/export-button.component';
import { SharedModule } from '@app/shared/shared.module';
import { ExportDialogComponent } from './export-dialog/export-dialog.component';
import { ExportDropdownComponent } from './export-dropdown/export-dropdown.component';
import { ExportCreativeDialogService } from './state/export-dialog.service';
import { ExportService } from './state/export.service';

@NgModule({
    declarations: [ExportDropdownComponent, ExportDialogComponent, ExportButtonComponent],
    imports: [CommonModule, SharedModule],
    providers: [DatePipe, ExportService, ExportCreativeDialogService],
    exports: [ExportDropdownComponent, ExportButtonComponent]
})
export class ExportCreativeModule {}
